import UnfoldLessIcon from '@mui/icons-material/UnfoldLess';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import { IconButton, Tooltip } from '@mui/material';
import { useIntl } from 'react-intl';
import { usePersonsTrackDensity } from '../hooks/usePersonsTrackDensity';
import { personsTrackMessages } from '../shared/persons-track-messages';

/**
 * Focus-track header control for Personas density.
 *
 * Shows an expand/collapse icon that switches between the compact summary
 * strip and per-person swim lanes. Sits to the left of the track eye toggle.
 */
export function PersonsTrackDensityToggle() {
  const { formatMessage } = useIntl();
  const { density, setDensity } = usePersonsTrackDensity();
  const expanded = density === 'lanes';
  const title = expanded
    ? formatMessage(personsTrackMessages.collapse)
    : formatMessage(personsTrackMessages.lanes);

  return (
    <Tooltip title={title}>
      <IconButton
        size="small"
        onClick={(event) => {
          event.stopPropagation();
          setDensity(expanded ? 'summary' : 'lanes');
        }}
        sx={{
          p: 0.25,
          width: 22,
          height: 22,
          color: 'text.secondary',
        }}
      >
        {expanded ? (
          <UnfoldLessIcon sx={{ fontSize: 18 }} />
        ) : (
          <UnfoldMoreIcon sx={{ fontSize: 18 }} />
        )}
      </IconButton>
    </Tooltip>
  );
}
